// 验证 porsche 邮箱
export function checkPorscheEmail(val) {
  val = val.toLowerCase()
  // TODO: 去掉测试入口 -- gotin邮箱后缀
  const reg = /^[0-9a-zA-Z\._-]+@(porsche)\.(de|cn)$/
  const regGotin = /^[0-9a-zA-Z_-]+@gotin\.online$/
  // TODO: 测试环境邮箱入口打开

  if (process.env.VUE_APP_RUN_ENV !== 'production') {
    const regTest = /^[0-9a-zA-Z_-]+@(qq|126|163|outlook)\.com$/
    return reg.test(val) || regGotin.test(val) || regTest.test(val)
  }
  return reg.test(val) || regGotin.test(val)
}
